module.exports = __webpack_public_path__ + "img/icon_share_link.1a7fdba3.svg";